"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conjunction = void 0;
var Conjunction;
(function (Conjunction) {
    Conjunction["AND"] = "AND";
    Conjunction["OR"] = "OR";
})(Conjunction = exports.Conjunction || (exports.Conjunction = {}));
//# sourceMappingURL=conjunction.js.map